export default __webpack_public_path__ + "static/media/12-32-28 3.1aedf62b.jpg";